import * as React from 'react';
import { cn } from './lib/cn';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  ref?: React.Ref<HTMLTextAreaElement>;
  /**
   * Comeca no tamanho de `rows` e cresce com o texto.
   *
   * Campo de duas linhas com barra de rolagem esconde o que a pessoa acabou
   * de escrever; um campo alto demais para uma frase curta gasta a tela dos
   * outros. Crescendo, ele e sempre do tamanho do proprio conteudo.
   */
  autoGrow?: boolean;
}

function ajusta(campo: HTMLTextAreaElement | null) {
  if (!campo) return;

  // Zerar antes de medir: `scrollHeight` nao encolhe sozinho quando o texto
  // diminui.
  campo.style.height = 'auto';
  campo.style.height = `${campo.scrollHeight}px`;
}

export function Textarea({ className, ref, autoGrow, onChange, ...props }: TextareaProps) {
  const interno = React.useRef<HTMLTextAreaElement>(null);

  React.useImperativeHandle(ref, () => interno.current as HTMLTextAreaElement);

  // biome-ignore lint/correctness/useExhaustiveDependencies: o valor que chega de fora muda a altura tanto quanto a digitacao
  React.useEffect(() => {
    if (autoGrow) ajusta(interno.current);
  }, [autoGrow, props.value]);

  return (
    <textarea
      ref={interno}
      className={cn(
        'flex w-full rounded-md border border-input bg-muted/50 transition-colors placeholder:text-muted-foreground hover:bg-muted focus-visible:border-primary focus-visible:bg-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 disabled:cursor-not-allowed disabled:opacity-50',
        'px-3 py-2 text-base sm:text-sm',
        // Com altura automatica, `min-h` fixo brigaria com a medida do texto.
        autoGrow ? 'resize-none overflow-hidden' : 'min-h-24 sm:min-h-20',
        className,
      )}
      onChange={(evento) => {
        if (autoGrow) ajusta(evento.currentTarget);
        onChange?.(evento);
      }}
      {...props}
    />
  );
}
